import { resources } from "@constants/hardcoded-strings";
import styles from "./no-data-component.less";

export const NoDataComponent = () => {
    return (
        <div className={styles.noDataComponent}>
            {resources.common.noDataToDisplay}
        </div>
    )
};